import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { CommentItem } from "components";
import "./styles.css";
import { connect } from "react-redux";
import * as actions from "redux/actions/commentActions";
import MiniLoader from "components/MiniLoader";
import { Translate, I18n } from "react-redux-i18n";
import { Camera , Cancel, Send } from "theme/icon";
// const useStyles = { CancelIcon
//     root: {
//         padding: theme.spacing(3),
//     },
//     content: {
//         marginTop: theme.spacing(2),
//     },
// };

const Comments = (props) => {
    const history = useHistory();
    const { className, ...rest } = props;

    const fileInputRef = useRef(null);

    const [values, setValues] = useState({
        comment: "",
        image: "",
        file: "",
        hasFile: false,
    });

    useEffect(() => {
        if (props.user_id) {
            props.loadList({ id: props.user_id }, props.token);
        }
    }, [props.user_id]);

    const onClickSend = (event) => {
        if (!props.user_id) {
            return;
        }
        const text = values.comment.trim();
        if (!text && !values.file) {
            return;
        }

        if (values.file) {
            const params = new FormData();
            params.append("comment", text || ' ');
            params.append("id", String(props.user_id));
            params.append("file", values.file);
            // First arg must be FormData itself — mapDispatch wraps it as { params }.
            props.newItem(params, props.token, values.image);
        } else {
            props.newItem({
                comment: text,
                id: props.user_id,
            }, props.token);
        }
        setValues({
            comment: "",
            image: "",
            file: "",
            hasFile: false,
        });
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    const onClickCloseImg = () => {
        setValues((prev) => ({
            ...prev,
            file: "",
            image: "",
            hasFile: false,
        }));
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    const onChange = (event) => {
        const { name, value } = event.target;
        setValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    const onClickUp = (item) => {
        //console.log(event)
        props.updateLike({
            comment_id: item.id,
            id: props.user_id,
            reaction: "1"
        }, props.token);

    }

    const onClickDown = (item) => {
        //console.log(event)
        props.updateLike({
            comment_id: item.id,
            id: props.user_id,
            reaction: "2"
        }, props.token);

    }

    const onClickComment = (item) => {
        props.setItem({ item });
        history.push(item?.id ? `/comment?id=${item.id}` : '/comment');
    };

    const onChangeImage = (e) => {
        const file = e.target.files?.[0];
        if (!file) {
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setValues((prev) => ({
                ...prev,
                file,
                image: reader.result,
                hasFile: true,
            }));
        };
        reader.readAsDataURL(file);
    };

    const onClickLoadMore = async (e) => {
        props.loadMore(
            {
                id: props.user_id,
                index: props.pageCount,
            }
            , props.token);
    }

    return (
        <div className="wall-container">
            <div className="card wall-compose">


                <input
                    ref={fileInputRef}
                    className="attach_file"
                    accept="image/*"
                    type="file"
                    id="open_input_img"
                    name="open_img"
                    onChange={onChangeImage}
                />
                <label htmlFor="open_input_img" className="icon-button wall-compose-image" aria-label="upload picture">
                    <Camera />
                </label>
                <div style={{ "width": "100%" }}>
                    <textarea
                        className="text_comment"
                        maxRows={2}
                        placeholder={I18n.t("what_you_mind")}
                        defaultValue=""
                        name="comment"
                        onChange={onChange}
                        value={values.comment}
                    />
                </div>
                <div>
                    <span onClick={onClickSend}>
                        <Send />
                    </span>
                </div>
            </div>
            {values.hasFile && (
                <div className="card" style={{}}>
                    <div className="card-actions" style={{ "display": "flex", "justifyContent": "flex-end" }}>
                        <span aria-label="up" onClick={onClickCloseImg}>
                            <Cancel />
                        </span>
                    </div>
                    <div style={{ "display": "flex", "justifyContent": "center", "paddingBottom": "10px" }}>
                        <img
                            src={values.image}
                            alt="img-coment"
                            className="img-responsive"
                            style={{ "maxHeight": "500px" }}
                        />
                    </div>
                </div>
            )}
            {
                props.list.map((item) => (
                    <CommentItem
                        key={item.id}
                        item={item}
                        onClickUp={() => { onClickUp(item) }}
                        onClickDown={() => { onClickDown(item) }}
                        onClickComment={() => { onClickComment(item) }}
                    />
                ))
            }
            {
                props.loading && <div style={{
                    "display": "flex",
                    "justifyContent": "center",
                    "padding": "10px"
                }}><MiniLoader />
                </div>
            }
            <div style={{
                "display": "flex",
                "justifyContent": "center",
                "padding": "10px"
            }}>
                {
                    props.pageSize === 25 && (
                        props.loadingMore ? (
                            <MiniLoader />
                        ) : (
                            <button className="btn btn-primary" onClick={onClickLoadMore}>
                                <Translate value="load_more" />
                            </button>
                        )
                    )
                }
            </div>
        </div>

    );
};

Comments.propTypes = {
    className: PropTypes.string,
    history: PropTypes.object
};

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        list: reducer.comment.list,
        error: reducer.comment.error,
        loading: reducer.comment.loading,

        pageCount: reducer.comment.page_count,
        pageSize: reducer.comment.page_size,
        loadingMore: reducer.comment.loadingMore,

    };
}
const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
    newItem: (params, token, previewMedia) =>
        dispatch(actions.newItem({ params, token, previewMedia })),
    updateLike: (params, token) =>
        dispatch(actions.updateLike({ params, token })),
    setItem: (data) =>
        dispatch(actions.setItem(data)),
    loadMore: (params, token) =>
        dispatch(actions.loadListScroll({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
